var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityServices = function SvgSecurityServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#security-services_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 4.167v31.666M33.333 20c0 8.18-8.923 14.13-12.17 16.025-.369.215-.553.323-.814.379a1.9 1.9 0 0 1-.698 0c-.26-.056-.445-.164-.814-.38C15.59 34.132 6.667 28.182 6.667 20v-7.97c0-1.333 0-2 .218-2.572a3.3 3.3 0 0 1 .911-1.315c.46-.406 1.084-.64 2.331-1.107l8.937-3.352c.346-.13.52-.194.698-.22q.238-.034.476 0c.179.026.352.09.698.22l8.937 3.352c1.247.467 1.871.701 2.33 1.107.407.357.72.809.912 1.315.218.572.218 1.239.218 2.571z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "security-services_svg__a",
    x1: 30.968,
    x2: -24.797,
    y1: 4.357,
    y2: 21.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgSecurityServices;